module.exports = __webpack_public_path__ + "img/facility7.4fe67a8e.png";